/* eslint-disable no-throw-literal */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import {
  Paper,
  MuiThemeProvider,
  Grid,
  ButtonGroup,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Add, Publish, Delete, School, GetApp } from "@material-ui/icons";
import { bindActionCreators } from "redux";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";

import PasswordReset from "../PasswordReset";
import StudentDialog from "./StudentDialog";
import FilterDataTable from "../../../utils/FilterDataTable";
import FilterDataTableSelect from "../../../utils/FilterDataTableSelect";
import * as studentDUCK from "../../../../redux/ducks/students.duck";
import { setLoader } from "../../../../redux/ducks/load.duck";
import { setAlert } from "../../../../redux/ducks/alert.duck";
import { BulkModal } from "../../../utils/BulkModal";
import { BulkJobStatus } from "../../../utils/BulkJobStatus";
import useMaintenance from "./hooks/useMaintenance";
import { getMuiTheme } from "./styles/student.style";
import CardView from "./components/cardView.component";
import { getAllStudents } from "../../../crud/api/students.crud";
import { downloadCsv } from "../../../utils/downloadCsv";
import notice from "../../../utils/notice";

const Student = ({
  students,
  school,
  studentActions,
  settingLoader,
  setAlert,
  staff_member_admin,
  is_admin,
}) => {
  const [csvLoading, setCsvLoading] = React.useState(false);

  const handleDownloadCsv = async () => {
    if (!school?.slug) {
      notice("Please select a school");
      return;
    }
    setCsvLoading(true);
    try {
      const items = await getAllStudents(school.slug);
      const headers = [
        "First Name",
        "Last Name",
        "Email",
        "Role",
        "Team",
        "Organization",
        "Status",
      ];
      const rows = items.map((item) => [
        item.user?.first_name || "",
        item.user?.last_name || "",
        item.user?.email || "",
        "Student",
        item.team?.name || "",
        school.name || "",
        item.user?.active ? "Active" : "Inactive",
      ]);
      downloadCsv(headers, rows, `${school.slug}_students.csv`);
    } catch (e) {
      console.error(e);
      notice("Error downloading CSV");
    } finally {
      setCsvLoading(false);
    }
  };

  // Build the bulk-athlete CSV template in the browser so it always
  // matches the columns the importer reads — including `sport` (and
  // `team`), which the old hosted template was missing.
  const handleDownloadTemplate = () => {
    const headers = [
      "first_name",
      "last_name",
      "email",
      "phone_number",
      "team",
      "sport",
    ];
    // Each sample row shows a different team/sport combination so the
    // admin can see when to fill which column: an exact team name, a
    // sport name (importer resolves/creates the team), or neither.
    const rows = [
      ["Katie", "Kovalchick", "kkovalchick@example.edu", "7245551234", "Women's Basketball Team", ""],
      ["Shannon", "Conley", "sconley@example.edu", "4125555678", "", "Women's Basketball"],
      ["Alex", "Rivera", "arivera@example.edu", "7175559012", "", ""],
    ];
    downloadCsv(headers, rows, "the_zone_csv_template.csv");
  };

  const {
    columns,
    options,
    openDialog,
    deleteStudents,
    createStudentBulk,
    onFinish,
    validateStudentBulk,
    isGrid,
    email,
    setEmail,
    query,
    setQuery,
    group,
    setGroup,
    bulk,
    setBulk,
    stepsBulk,
    setStepsBulk,
    setBulkLoading,
    setBulkModal,
    errorsBulk,
    teams,
    bulkLoading,
    dialog,
    bulkModal,
    onDeleteBulk,
    isVisibleDeleteStudentBulkSButton,
  } = useMaintenance({
    is_admin,
    staff_member_admin,
    studentActions,
    settingLoader,
    setAlert,
    school,
    students,
  });

  return (
    <>
      <div className="table-container">
        <Grid container columns={12} className=" p-2">
          <Grid
            container
            item
            spacing={2}
            xs
            direction={"row"}
            className="mb-3"
          >
            <Grid container item xs style={{ minWidth: "300px" }}>
              <FilterDataTable query={query} setQuery={setQuery} />
            </Grid>
            <Grid container item xs style={{ minWidth: "300px" }}>
              <FilterDataTableSelect
                options={teams}
                values={group}
                handleChange={setGroup}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            xs
            style={{ maxHeight: "40px" }}
            wrap="nowrap"
            justify="flex-end"
            className="mb-3"
          >
            <>
              <BulkJobStatus
                stepsBulk={stepsBulk}
                onFinish={onFinish}
                errorsBulk={errorsBulk}
                entity="athletes"
              />
              {isVisibleDeleteStudentBulkSButton && (
                <Button
                  id="delete_bulk_student_btn"
                  className="mr-3"
                  variant="contained"
                  color="secondary"
                  onClick={() => onDeleteBulk()}
                  startIcon={<Delete />}
                >
                  Bulk Delete
                </Button>
              )}

              {is_admin && (
                <Button
                  id="download_students_csv_btn"
                  className="mr-3"
                  variant="contained"
                  color="default"
                  onClick={handleDownloadCsv}
                  startIcon={csvLoading ? <CircularProgress size={18} color="inherit" /> : <GetApp />}
                  disabled={csvLoading}
                >
                  {csvLoading ? "Downloading..." : "Download CSV"}
                </Button>
              )}

              <Button
                id="create_bulk_student_btn"
                className="mr-3"
                variant="contained"
                color="primary"
                onClick={() => setBulkModal(true)}
                startIcon={<Publish />}
              >
                Bulk Upload
              </Button>


              <Button
                id="create_student_btn"
                variant="contained"
                color="secondary"
                onClick={() => openDialog("create")}
                startIcon={<Add />}
              >
                New Athlete
              </Button>
            </>
          </Grid>
        </Grid>
        <Paper>
          <MuiThemeProvider theme={getMuiTheme({ isGrid })}>
            <ButtonGroup
              variant="text"
              style={{
                position: "absolute",
                zIndex: 1,
                margin: 10,
              }}
            ></ButtonGroup>
            <MUIDataTable
              // title="Admin"
              columns={columns}
              data={students.data}
              options={options}
            />
          </MuiThemeProvider>
        </Paper>
        {isGrid && <CardView students={students} School={School} openDialog={openDialog} deleteStudents={deleteStudents} is_admin={is_admin} staff_member_admin={staff_member_admin} />}
      </div>
      <StudentDialog mode={dialog} setDialog={openDialog} />
      <PasswordReset email={email} setEmail={setEmail} />
      {bulkModal && (
        <BulkModal
          showSelectTeam={true}
          onDownloadTemplate={handleDownloadTemplate}
          errorsBulk={errorsBulk}
          setSteps={setStepsBulk}
          open={bulkModal}
          validateBulk={validateStudentBulk}
          setOpen={setBulkModal}
          bulk={bulk}
          steps={stepsBulk}
          setBulk={setBulk}
          school={school}
          loading={bulkLoading}
          bulkRequest={createStudentBulk}
          setLoading={setBulkLoading}
        />
      )}
    </>
  );
};

const mapStateToProps = (store) => {
  return {
    school: store.school.selected_school,
    students: store.student.students,
    staff_member_admin: store.auth.user?.staff_member_admin,
    is_admin: store.auth.user?.is_admin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
  studentActions: bindActionCreators(studentDUCK.actions, dispatch),
  setAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Student);
